import { useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil';
import { getDeliveryFences } from '../../services/deliveryFenceService';
import {
  deliveryFencesPageState,
  deliveryFencesState,
  loadingDeliveryFencesState,
  searchDeliveryFenceState,
  selectedDeliveryFenceIdState,
  updateDeliveryFencesState,
} from '../../storage/deliveryFences';
import { DeliveryFenceCore } from '../../types/fence';
import { PaginatedProvider } from './PaginatedProvider';

export function DeliveryFencesProvider() {
  const setLoadingDeliveryFences = useSetRecoilState(loadingDeliveryFencesState);
  const setPaginatedDeliveryFences = useSetRecoilState(deliveryFencesState);
  const updateDeliveryFences = useRecoilValue(updateDeliveryFencesState);
  const resetUpdateDeliveryFences = useResetRecoilState(updateDeliveryFencesState);
  const resetSelectedDeliveryFenceId = useResetRecoilState(selectedDeliveryFenceIdState);

  return (
    <PaginatedProvider<DeliveryFenceCore>
      searchState={searchDeliveryFenceState}
      pageState={deliveryFencesPageState}
      getPaginated={getDeliveryFences}
      setPaginated={setPaginatedDeliveryFences}
      onSearchChange={resetSelectedDeliveryFenceId}
      onUpdateFinish={() => {
        resetUpdateDeliveryFences();
      }}
      setLoading={setLoadingDeliveryFences}
      update={updateDeliveryFences}
    />
  );
}
